<template>
  <div class="adminLog" style=" margin: auto">
    <div class="md-layout md-gutter md-alignment-center-space-between" style="width:100%">
 
      <div class="md-layout-item md-size-100">
          <div class="md-layout md-gutter md-alignment-bottom-space-between">
            <div class="md-layout-item" style="margin-bottom: 10px">
                <div class="md-layout md-gutter md-alignment-center-center">
                    <md-chip style="margin-bottom: 5px" :class="typeSelect.includes('server') ? 'md-primary' : ''"   @click="changeState('server')"    md-clickable>Server</md-chip>
                    <md-chip style="margin-bottom: 5px" :class="typeSelect.includes('transaction') ? 'md-primary' : ''"   @click="changeState('transaction')"    md-clickable>Transaction</md-chip>
                    <md-chip style="margin-bottom: 5px" :class="typeSelect.includes('system') ? 'md-primary' : ''"   @click="changeState('system')"    md-clickable>System</md-chip>
                </div>
            </div>
          <div class="md-layout-item " style="margin-bottom: 10px">

                  <md-chip @click="showDateRangeDialog = true;" md-clickable>
                    <span style="padding: 15px;" v-if="selectedStartDate && selectedStartDate != ''"><b>From: </b> {{ dateFormatInit }}</span>

                    <span style="padding: 15px;" v-if="selectedEndDate && selectedEndDate != ''"><b>To: </b> {{ dateFormatEnd }}</span>

                  </md-chip>

          </div>
            <div class="md-layout-item" style="margin-bottom: 10px">
                <md-chip @click="searchUserName='';searchUser();dialogSelectedUsers=selectedUsers;selectAllUsers = dialogSelectedUsers.length === users.length;showSelectedUsers = true;" md-clickable>Created by ({{selectedUsers.length}} Selected)</md-chip>
            </div>
            <md-field class="md-layout-item" style="margin-left: 20px;margin-bottom: 10px">
                <label>Search</label>
                <md-input v-model="searchText" @change="findByFilters();"/>
            </md-field>

            <!-- <div class="md-layout-item md-size-5">
              <md-button class="md-icon-button md-primary" @click="findByFilters()">
                <md-icon>search</md-icon>
              </md-button>
            </div>-->
          </div>
      </div>
    </div>
    <div  class="md-layout md-gutter md-alignment-center-space-between" style="margin-top:20px;">
      <admin-log-table :searchFilters="searchFilters"></admin-log-table>
    </div>
        <md-dialog :md-active.sync="showDateRangeDialog">
            <md-dialog-title class="md-dialog-title">Date Range</md-dialog-title>
            <div class="dialog-content spaced">
                <div class="md-layout ">

                    <CustomDateField  class="md-layout-item" label="Select staring date" v-model="selectedStartDate"/>
                </div>
                <div class="md-layout ">
                            <CustomDateField class="md-layout-item"  label="Select ending date" v-model="selectedEndDate"/>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-accent" @click="showDateRangeDialog = false">Close</md-button>
                 <md-button class="md-primary" @click="showDateRangeDialog = false;findByFilters();" 
                :disabled="!validDateFilter">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showSelectedUsers" > 
            <md-dialog-title class="md-dialog-title">Select users</md-dialog-title>

            <div class="dialog-content spaced">
                <div class="md-layout md-gutter md-alignment-center-left">
                    <div class="md-layout-item md-size-40">
                        <md-checkbox  v-model="selectAllUsers" @change="changeUsersSelection()" :disabled="filteredUsers.length !== users.length">Select All</md-checkbox>

                    </div>
                    <div class="md-layout-item md-size-55">
                    
                        <md-field>
                            <label for="">Search</label>
                            <md-input v-model="searchUserName"  @change="searchUser()"></md-input>
                        </md-field>
                    </div>
                </div>         
                <hr>
                <md-checkbox class="md-primary md-layout " v-model="dialogSelectedUsers" @change="selectAllUsers = dialogSelectedUsers.length === filteredUsers.length;" v-for="user in filteredUsers" v-bind:key="user.id" :value="user.id"> {{ user.text }}</md-checkbox>
            </div>
            <hr>
            <md-dialog-actions>
                <label style="color:red" v-if="dialogSelectedUsers.length == 0">You must select at least 1 User</label>
                <label v-if="dialogSelectedUsers.length > 0">Selected: {{dialogSelectedUsers.length}} User(s)</label>
                <md-button class="md-layout-item" @click="showSelectedUsers = false">Close</md-button>

                <md-button class="md-layout-item md-primary md-raised" :disabled="dialogSelectedUsers.length == 0" @click="selectedUsers=dialogSelectedUsers;showSelectedUsers = false; selectedLabel=selectedUsers.length + ' User(s) selected';findByFilters();"  >Save</md-button>

            </md-dialog-actions>
        </md-dialog>
  </div>
</template>

<script>
import axios from "axios";
 import moment from 'moment'
import Vue from "vue";
import AdminLogTable from '../components/AdminLogTable.vue';
import CustomDateField from "@/components/CustomDateField.vue";
export default {
  name: "AdminLog",
  components: {
    AdminLogTable,
    CustomDateField
  },

  computed:{
    validDateFilter() {
      return   moment().isValid() || moment(this.selectedEndDate).isValid();
    },
    dateFormatInit() {
      return moment(this.selectedStartDate).format(this.dateFormat)
    },
    dateFormatEnd() {

      return moment(this.selectedEndDate).format(this.dateFormat)
    }
  },
  created(){
    this.getPermission('users');
    this.usersList();
    
  },
  data() {
      
    return {
      dateFormat: Vue.prototype.$generalConfiguration['dateFormat'],
      searchFilters:{},
      searchText: "",
      typeSelect: ['server', 'transaction', 'system'],
      selectedStartDate: moment().add(-3, 'months').toDate(),
      selectedEndDate: moment().toDate(),
      showDateRangeDialog: false,
      showSelectedUsers: false,
      selectAllUsers: true,
      filteredUsers: [],
      selectedUsers: [],
      users:[],
      searchUserName: '',
      dialogSelectedUsers: [],


    };
  },
  methods: {
     usersList(){
            
            axios({
                method: "get",
                url: "/users/getAllUsers",
                baseURL: process.env.VUE_APP_BASE_API,
                headers: {
                Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
                },

            }).then((response) => {
                this.users = response.data.map(el => { 
                    el.text = el.firstName + ' ' + el.lastName + ' (' + el.email + ')';
                    return el;
                });

                this.selectedUsers = this.users.map(el => { return el.id;});

                this.findByFilters();
            }).catch(function () {
                console.log("FAILURE!!");
            });

        },

    getPermission(name){
      const permissions = Vue.prototype.$userData.permissions|| [];
      if ( !permissions.includes(name)) {
        this.$router.push("Landing");
      }
    },
    changeState(state){
      var index = this.typeSelect.indexOf(state);
      if(index > - 1){
        this.typeSelect.splice(index, 1);
      }else{
        this.typeSelect.push(state);
      }
      this.findByFilters()
    },
    findByFilters(){
        this.searchFilters = {}
        if(this.selectedUsers.length > 0){ this.searchFilters.userId =  this.selectedUsers;}
        if(this.typeSelect.length > 0){ this.searchFilters.type = this.typeSelect;}
        if(this.selectedStartDate){ this.searchFilters.dateInit = moment(this.selectedStartDate).format('YYYY-MM-DDT00:00:00Z');}
        if(this.selectedEndDate){  this.searchFilters.dateEnd = moment(this.selectedEndDate).format('YYYY-MM-DDT23:59:59Z');}
        if(this.searchText.length >= 3){ this.searchFilters.searchText = this.searchText;}
    },
    changeUsersSelection(){
      if(this.selectAllUsers){
          this.dialogSelectedUsers = this.users.map(el => { return el.id;});
      }else{
          this.dialogSelectedUsers = [];
      }
    },
    searchUser(){
      this.filteredUsers = this.users.filter(user => {
          return user.text.toLowerCase().includes(this.searchUserName.toLowerCase()) ||
          user.firstName.toLowerCase().includes(this.searchUserName.toLowerCase()) || 
            user.lastName.toLowerCase().includes(this.searchUserName.toLowerCase()) ||  
            user.email.toLowerCase().includes(this.searchUserName.toLowerCase());

      })
    },
  },
};
</script>
<style lang="scss">
.md-list-item-content {
  justify-content: unset;
}
.t-head {
  display: flex;
}
.t-title-group {
  display: flex;
  margin-left: 25px;
}
.t-number {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background: #e94e1b;
  color: white;
}

.t-body-wrapper {
  padding-left: 50px;
  margin-left: 12.5px;
  border-left: 1px solid lightgray;
  min-height: 20px;
  max-height: 0;

  overflow: hidden;
  padding-top: 1px;
  transition: all 1s ease;
}

.t-body-wrapper.expand {
  max-height: 200px !important;
}

.t-title-info {
  margin-left: 5px;
}

.t-title-type {
  font-weight: bold;
  color: #737373;
  font-size: 16px;
}

.t-title-email {
  color: #969696;
  font-size: 12px;
}

.t-record {
  margin-top: 40px;
  cursor: pointer;
}
.t-body-content i {
  font-size: 1.2em !important;
}
.t-body-content {
  margin-bottom: 15px;
}

.t-record:last-child .t-body-wrapper {
  border: none;
}
.t-record-group {
  // width: 70%;
  // margin:auto;
}
  .dialog-content{
    padding: 0px;
    
    &.spaced{
      overflow-y: auto;
      margin: 20px;
    }
    
  }
</style>